import React from 'react';
import { StyleSheet, View } from 'react-native';
import PlaneTakeoffSvg from '@assets/images/svg/plane-takeoff.svg';

export function PlaneTakeoffIcon({ size = 24 }: { size?: number }) {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <PlaneTakeoffSvg
                width={size}
                height={size}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default PlaneTakeoffIcon;
